import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import VerifiedBadge from '../common/components/VerifiedBadge';
import { findVnodeByClass } from './utils/vnodeTree';
export default function addBadgeToCommentPost() {
  extend('flarum/forum/components/CommentPost', 'headerItems', function (items) {
    const post = this.attrs.post;
    const user = post && post.user && post.user();
    if (!user || !user.isVerified || !user.isVerified()) return;
    items.add('verified', m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--post"
    }), 95);
  });

  // O preview de resposta (ReplyPlaceholder) monta o header direto com <PostUser>
  // e não passa por `headerItems`, então o selo é injetado aqui.
  extend('flarum/forum/components/ReplyPlaceholder', 'view', function (vnode) {
    if (!vnode || vnode.tag !== 'article') return;
    const user = app.session.user;
    if (!user || !user.isVerified || !user.isVerified()) return;
    const header = findVnodeByClass(vnode, 'Post-header');
    if (!header || !Array.isArray(header.children)) return;

    // Mesmo wrapper de um post real (`ul > li.item-verified`) para herdar o alinhamento.
    header.children = [...header.children, m("ul", null, m("li", {
      className: "item-verified"
    }, m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--post"
    })))];
  });
}